export const FEEDBACK_TYPES = {
  DIRECT_REPORT: 'b3b5fd3f-e477-4a6c-9e7d-46384e8971b0',
  MANAGER: '52bf9471-5689-489b-910b-80ba4145f865',
  PEER: '57568ca4-149c-4087-aa49-b6cb556e5f53',
  SELF_EVALUATION: '0368322b-03c8-40a7-8318-09a5c6ecd072'
} as const; 